import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import camelcaseKeys from 'camelcase-keys'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSms,
  faCalendarCheck,
  faCalendarMinus,
  faCalendarTimes,
  faCalendar,
  faEnvelope
} from '@fortawesome/free-solid-svg-icons'

import reserveApi from '../../../utils/axios'

import DateFormat, { dateHasPast } from '../../utils/dateFormat'

import { AdminTd, AdminTh, AdminTable } from '../Tables'
import { Link } from 'react-router-dom'

const Show = () => {
  const facility = useSelector(store => store.facilities.facility)
  const [adminFacilityRequests, setAdminFacility] = useState([])

  useEffect(() => {
    reserveApi.get(`/admin/facilities/${facility.id}/requests`).then(response => {
      setAdminFacility(camelcaseKeys(response.data, { deep: true }))
    })
  }, [facility])

  return (
    <div className="min-h-screen">
      <AdminTable>
        <thead>
          <tr>
            <AdminTh>Status</AdminTh>
            <AdminTh>User</AdminTh>
            <AdminTh>Dates</AdminTh>
            <AdminTh>Nights</AdminTh>
            <AdminTh>Sites</AdminTh>
            <AdminTh>Pref</AdminTh>
            <AdminTh>
              Matches
              <br />
              Active / Total
            </AdminTh>
            <AdminTh>
              Notifications
              <br />
              24hr / All
            </AdminTh>
            <AdminTh>Checked</AdminTh>
            <AdminTh>Checked At</AdminTh>
            <AdminTh>Created At</AdminTh>
          </tr>
        </thead>
        <tbody>
          {adminFacilityRequests.map(ar => (
            <tr key={ar.uuid}>
              <AdminTd>
                <a href={`/${ar.uuid}`}>
                  {ar.status === 'active' && !dateHasPast(ar.dateEnd) && (
                    <FontAwesomeIcon icon={faCalendarCheck} className="text-xl text-green-700" />
                  )}
                  {ar.status === 'active' && dateHasPast(ar.dateEnd) && (
                    <FontAwesomeIcon icon={faCalendarMinus} className="text-xl text-orange-400" />
                  )}
                  {ar.status === 'canceled' && (
                    <FontAwesomeIcon icon={faCalendarTimes} className="text-xl text-red-700" />
                  )}
                  {ar.status === 'paused' && !dateHasPast(ar.dateEnd) && (
                    <FontAwesomeIcon icon={faCalendar} className="text-xl text-green-200" />
                  )}
                </a>
              </AdminTd>
              <AdminTd>
                <Link to={`/admin/users/${ar.userId}`}>{ar.userId}</Link>
              </AdminTd>
              <AdminTd>
                <DateFormat format="MM/DD" date={ar.dateStart} />
                &nbsp;-&nbsp;
                <DateFormat format="MM/DD/YYYY" date={ar.dateEnd} />
              </AdminTd>
              <AdminTd>{ar.stayLength}</AdminTd>
              <AdminTd>{ar.siteType} {ar.siteCount}</AdminTd>
              <AdminTd>
                <span className="flex space-x-2">
                  {ar.notifySms && <FontAwesomeIcon icon={faSms} className="text-xl text-gray-400" />}
                  {ar.notifyEmail && <FontAwesomeIcon icon={faEnvelope} className="text-xl text-gray-400" />}
                </span>
              </AdminTd>
              <AdminTd>
                {ar.matchesAvailabileCount} / {ar.matchesCount}
              </AdminTd>
              <AdminTd>
                {ar.availabilityNotifications24Count} / {ar.availabilityNotificationsCount}
              </AdminTd>
              <AdminTd>{ar.checkedCount}</AdminTd>
              <AdminTd>{ar.checkedAt && <DateFormat format="M/D/YYYY hh:mm" date={ar.checkedAt} />}</AdminTd>
              <AdminTd>{ar.createdAt && <DateFormat format="M/D/YYYY hh:mm" date={ar.createdAt} />}</AdminTd>
            </tr>
          ))}
        </tbody>
      </AdminTable>
    </div>
  )
}

export default Show
